import { Button, Heading, Icon } from '@lmc/ui-kit'
import { Divider, Modal } from 'antd'
import { NAMESPACE } from 'locale'
import { generalTranslations } from 'locale/general'
import { incidentReportsConstants } from 'locale/incidentReports'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { ModalFooter } from '../display/commonStyledComponents'

interface IncidentTypeChangeModalProps {
  open: boolean
  handleCancel: () => void
  onConfirm: () => void
}

const IncidentTypeChangeModal = ({
  open,
  handleCancel,
  onConfirm
}: IncidentTypeChangeModalProps) => {
  const { t } = useTranslation(NAMESPACE.INCIDENT_REPORTS)

  return (
    <Modal
      open={open}
      centered
      onCancel={handleCancel}
      footer={[
        <ModalFooter>
          <Button onClick={handleCancel}>
            {t(generalTranslations.CANCEL)}
          </Button>
          <Button variant="primary" onClick={onConfirm}>
            {t(generalTranslations.CONFIRM)}
          </Button>
        </ModalFooter>
      ]}
    >
      <>
        <Title level={3}>
          <Icon name="InfoCircleOutlined" color="#DE7C12" />
          {t(incidentReportsConstants.INCIDENT_TYPE_CHANGED)}
        </Title>
        <Divider />
      </>
      <div>{t(incidentReportsConstants.INCIDENT_TYPE_WARNING)}</div>
      <Divider />
    </Modal>
  )
}

const Title = styled(Heading)`
  color: ${(props) => props.theme.color.neutral.color3};
  display: flex;
  flex-direction: row;
  gap: 8px;
`

export default IncidentTypeChangeModal
